import type { Currency } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import { Icon } from '@swf/sports/components';

import Banner from '../Banner/Banner';

import { TXTWCL_You_Won_N0X } from './WinBanner.messages.json';
import styles from './WinBanner.scss';

interface Props {
  actualWin: number;
  currency?: Currency;
}

const WinBanner: React.FC<Props> = ({ actualWin, currency }) => (
  <Banner>
    <span className={styles.iconWrapper}>
      <Icon name="star" size="x2" />
    </span>

    <Translation
      {...TXTWCL_You_Won_N0X}
      values={{ 0: <CurrencyAmount dollarValue value={actualWin} currency={currency} /> }}
    />
  </Banner>
);

export default WinBanner;
